import React from "react";
import { Provider } from "mobx-react";

import MessagingStorage from "../../storages/MessagingStorage";
import Messaging from "./Messaging";

const Container = ({ maxAttachmentBytes }) => {
  const messagingStorage = new MessagingStorage(
    Application.currentUser.locations,
    maxAttachmentBytes
  );
  const storage = { messagingStorage };

  return (
    <Provider {...storage}>
      <Messaging />
    </Provider>
  );
};

export default Container;
